import React, { Component } from 'react';
import './heading-page.css';
import './animate.css';

export default class HeadingPress extends Component {
    static propTypes = {};

    render() {
        return (
        <div className="heading-page">
            <div className="heading-page-container fadeInUp">
                <h1>Press</h1>
                <p>Download all of our press and media resources here, or get in touch with a media contact.</p>
                <a className="download-button" href="">Download Press Kit</a>
            </div>
        </div>
        );
    }
}
